
<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" class="close-button" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<h2 mat-mdc-dialog-title *ngIf="!guy.Id">{{ 'T4.Service.ServiceGuyDialog.lblHeadline' | translate : 'New service guy'}}</h2>
<h2 mat-mdc-dialog-title *ngIf="guy.Id">{{ guy.Identifier }}</h2>

<t4-container>
  <mat-dialog-content>

    <mat-tab-group>
      <mat-tab label="{{'T4.Service.ServiceGuyDialog.tblGeneral' | translate : 'General' }}">
        <div class="row" style="margin-left:0px;">
          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-3">
            <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtServiceGuyType' | translate : 'Service guy type'}}</mat-label>
            <mat-select [(ngModel)]="guy.ServiceGuyTypeId">
              <mat-option [value]="r.Id" *ngFor="let r of serviceGuysTypes">{{r.Name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <form [formGroup]="form">
          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-6">
            <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtFirstName' | translate : 'First name'}}</mat-label>
            <input id="txtFirstname"
                   autocomplete="off"
                   matInput
                   formControlName="firstName">
            <mat-error>{{ 'T4.Service.ServiceGuyDialog.txtFirstName_required' | translate : 'A first name is required'}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-6">
            <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtLastname' | translate : 'Last name'}}</mat-label>
            <input id="txtLastname"
                   autocomplete="off"
                   matInput
                   formControlName="lastName">
            <mat-error>{{ 'T4.Service.ServiceGuyDialog.txtLastname_required' | translate : 'A last name is required'}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-6">
            <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtEmail' | translate : 'Email'}}</mat-label>
            <input id="txtEmail"
                   autocomplete="off"
                   matInput
                   formControlName="email">
            <mat-error>{{ 'T4.Service.ServiceGuyDialog.txtEmail_required' | translate : 'An email is required'}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-6">
            <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtPhone2' | translate : 'MobilePhone'}}</mat-label>
            <input id="txtPhone"
                   autocomplete="off"
                   matInput
                   formControlName="phone">
            <mat-error>{{ 'T4.Service.ServiceGuyDialog.txtPhone_required' | translate : 'A mobile phone number is required'}}</mat-error>
          </mat-form-field>

          <div class="row" style="margin-left:0px; margin-right:0px;">
            <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col">
              <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtCompanyName' | translate : 'Company name'}}</mat-label>
              <input id="txtCompanyName"
                     autocomplete="off"
                     matInput
                     formControlName="companyName">
            </mat-form-field>

            <div *ngIf="guy.Id && guy.AssignedLocations" class="col-6">
              <ng-container *ngIf="guy.AssignedLocations.length > 0" appearance="outline" style="margin-bottom: 10px;">
                <h5>{{ 'T4.Service.ServiceGuyDialog.txtAssingedLocations' | translate : 'Assinged Locations'}}</h5>
                <p *ngFor="let location of guy.AssignedLocations;index as i">{{i + 1}}. {{location.Name}}</p>
              </ng-container>
              <ng-container *ngIf="guy.AssignedLocations.length === 0" appearance="outline" style="margin-bottom: 10px;">
                <h5>{{ 'T4.Service.ServiceGuyDialog.txtAssingedLocations' | translate : 'Assinged Locations'}}</h5>
                <p>No assigned locations</p>
              </ng-container>
            </div>
          </div>


          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-6">
            <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtCustomerAccount' | translate : 'Customer Account'}}</mat-label>
            <input id="txtEmail"
                   autocomplete="off"
                   matInput
                   formControlName="customerAccount">
            <mat-error>{{ 'T4.Service.ServiceGuyDialog.txtCustomerAddress_required' | translate : 'An Customer Address is required'}}</mat-error>
          </mat-form-field>

          <hr style="width:100%;text-align:left;margin-left:0">
          <br />
          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-12">
            <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtDeliveryAddress' | translate : 'Delivery Address'}}</mat-label>
            <input id="txtEmail"
                   autocomplete="off"
                   matInput
                   formControlName="deliveryaddress">
            <mat-error>{{ 'T4.Service.ServiceGuyDialog.txtdeliverydeliveryAddress_required' | translate : 'An delivery address is required'}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-2">
            <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtDeliveryZipcode' | translate : 'Delivery ZipCode'}}</mat-label>
            <input id="txtZipcode"
                   autocomplete="off"
                   matInput
                   formControlName="deliveryzipcode">
            <mat-error>{{ 'T4.Service.ServiceGuyDialog.txtdeliveryZipcode_required' | translate : 'An delivery zipcode is required'}}</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-10">
            <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtDeliveryCity2' | translate : 'Delivery City'}}</mat-label>
            <input id="txtdeliveryCity"
                   autocomplete="off"
                   matInput
                   formControlName="deliverycity">
            <mat-error>{{ 'T4.Service.ServiceGuyDialog.txtdeliverydeliveryCity_required' | translate : 'An delivery city is required'}}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" style="margin-bottom: 10px;" class="col-6">
            <mat-label>{{ 'T4.Service.ServiceGuyDialog.txtDeliveryCountry' | translate : 'Country'}}</mat-label>
            <input id="txtCountry"
                   autocomplete="off"
                   matInput
                   formControlName="deliverycountry">
            <mat-error>{{ 'T4.Service.ServiceGuyDialog.txtdeliverydeliveryCountry_required' | translate : 'An delivery country is required'}}</mat-error>
          </mat-form-field>

        </form>
      </mat-tab>

      <ng-container *ngIf="guy.Id">
        <mat-tab label="{{'T4.Service.ServiceGuyDialog.tblStock' | translate : 'Stock' }}">

          <t4-data-table #tblInStock [allowFilter]="false" [allowPaging]="false" [allowExcel]="false" [rawData]="serviceguystock" headline="{{'T4.Service.ServiceGuyDialog.lblserviceguystock' | translate : 'Stock' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false">

            <ng-container matColumnDef="ItemId">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'T4.Service.ServiceGuyDialogItemId' |translate : 'Item Id' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.ItemId }}<ng-container></ng-container></mat-cell>
            </ng-container>

            <ng-container matColumnDef="Item.Name">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'T4.Service.ServiceGuyDialogArticleName' |translate : 'Article name' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.Item.Name }}<ng-container></ng-container></mat-cell>
            </ng-container>

            <ng-container matColumnDef="CurrentStock">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'T4.Service.ServiceGuyDialogCurrentStock' |translate : 'Current stock' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.OnHand }}<ng-container></ng-container></mat-cell>
            </ng-container>

            <ng-container matColumnDef="StockSetting.MinLevel">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'T4.Service.ServiceGuyDialogminstocklevel' |translate : 'Minimum stocklevel' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.StockSetting.MinLevel }}<ng-container></ng-container></mat-cell>
            </ng-container>

          </t4-data-table>
        </mat-tab>
      </ng-container>

      <ng-container *ngIf="guy.Id">
        <mat-tab label="{{'T4.Service.ServiceGuyDialog.tblAssets' | translate : 'Assets'}}">

          <t4-data-table #tblInventoryAsset [allowFilter]="false" [allowPaging]="false" [allowExcel]="false" [rawData]="inventoryAssets" headline="{{'T4.Service.ServiceGuyDialog.lblserviceguystock' | translate : 'Stock' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false">

            <!-- inventoryAssets -->

            <ng-container matColumnDef="SerialId">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px; justify-content: left;">{{'T4.Service.ServiceGuyDialogSerialId' |translate : 'Serial Id' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" (click)="assetInfomation(row.AssetId)" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px; justify-content: left;">{{ row.SerialId }}</mat-cell>
            </ng-container>

            <!--
            <ng-container matColumnDef="AssetId">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 300px; justify-content: left;">{{'T4.Service.ServiceGuyDialogAssetId' |translate : 'Asset Id' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 300px; justify-content: left;">{{ row.AssetId }}</mat-cell>
            </ng-container>

        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 50px; justify-content: center;">{{'T4.Service.ServiceGuyDialogStatus' |translate : 'Status' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 50px; justify-content: center;">
            <mat-icon *ngIf="row.Status == 0" matSuffix style="color:green">recommend</mat-icon>
            <mat-icon *ngIf="row.Status == 1" matSuffix style="color:red;">delete_forever</mat-icon>
          </mat-cell>
        </ng-container>
           -->


            <ng-container matColumnDef="CreateAt">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 80px; justify-content: center;">{{'T4.Service.ServiceGuyDialogCreateAt' |translate : 'CreatedAt' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 80px; justify-content: center;">{{ row.CreatedAt | date : 'dd/M HH:mm' }}</mat-cell>
            </ng-container>
            <!--
          <ng-container matColumnDef="DeletedAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100px; justify-content: center;">{{'T4.Service.ServiceGuyDialogDeletedAt' |translate : 'DeletedAt' }}</mat-header-cell>
            <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100px; justify-content: center;">{{ row.DeletedAt | date : 'dd/M HH:mm' }}</mat-cell>
          </ng-container>
        -->

            <ng-container matMenuContent matColumnDef="transScrap">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100px; justify-content: center;"></mat-header-cell>
              <mat-cell *matCellDef="let row2" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100px; justify-content: right; margin-left: auto;">
                <button mat-stroked-button [matMenuTriggerFor]="menuAction" [matMenuTriggerData]="{Object: row2}" style=" width: 110px; margin-right: -10px;">
                  {{ 'T4.Service.ServiceGuyDialog.lblInventoryAssetsAction' | translate : 'Action' }} <!--{{row2.AssetId}}--> <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
              </mat-cell>
            </ng-container>

            <mat-menu #menuAction="matMenu">
              <ng-template matMenuContent let-Object="Object">
                <button (click)="Transfer(Object)" mat-menu-item color="primary"><mat-icon style="color:green">recommend</mat-icon>{{ 'T4.Service.ServiceGuyDialog.lblInventoryAssetTransfer' | translate : 'Transfer'}}</button>
                <button (click)="Scrap(Object)" mat-menu-item color="primary"><mat-icon style="color: red">delete_forever</mat-icon>{{ 'T4.Service.ServiceGuyDialog.lblInventoryAssetScrap' | translate : 'Scrap'}}</button>
              </ng-template>
            </mat-menu>

          </t4-data-table>
        </mat-tab>
      </ng-container>
      <ng-container *ngIf="guy.Id">
        <mat-tab label="{{'T4.Service.ServiceGuyDialog.tblAssignments' | translate : 'Assignments'}}">
          <ng-container toolbar>
            <button mat-button color="primary" (click)="addNewAssignment()"><mat-icon>add</mat-icon>{{ 'T4.Service.ServiceGuyDialog.btnServiceguyAssignedLocations' | translate : 'Add Location'}}</button>
          </ng-container>
          <t4-data-table #tblAssignedLocations [allowFilter]="false" [allowPaging]="false" [allowExcel]="false" [rawData]="guy.AssignedLocations" headline="{{'T4.Service.ServiceGuyDialog.lblserviceguyAssignedLocations' | translate : 'Assigned Locations' }}" matSort matSortDirection="desc" [autoGenerateColumns]="false">
            <ng-container matColumnDef="LocationId">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{'T4.Service.ServiceGuyDialogLocationId' |translate : 'Location Id' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{ row.LocationId }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Name">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{'T4.Service.ServiceGuyDialogLocationName' |translate : 'Name' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{ row.Name }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Email">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{'T4.Service.ServiceGuyDialogEmail' |translate : 'Email' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{ row.Email }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Address">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 200px;">{{'T4.Service.ServiceGuyDialogLocationAddress' |translate : 'Address' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 200px;">{{ row.Address + ',' + row.City }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Country">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{'T4.Service.ServiceGuyDialogLocationCountry' |translate : 'Country' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{ row.Country }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Phone">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{'T4.Service.ServiceGuyDialogLocationPhone' |translate : 'Phone' }}</mat-header-cell>
              <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{ row.Phone }}</mat-cell>
            </ng-container>
          </t4-data-table>
        </mat-tab>
      </ng-container>
    </mat-tab-group>

    <div class="loader" *ngIf="loading.dialog">
      <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
      <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;"></mat-progress-bar>
    </div>

  </mat-dialog-content>
</t4-container>

<mat-dialog-actions>
  <ng-container *ngIf="guy.Id">
    <div class="col-6" style="text-align: left; padding-right: 5px; padding-right: 5px;">
      <button mat-stroked-button color="primary" style="margin: 3px;" (click)="updatestock()">
        {{'T4.Service.ServiceGuyDialog.cmdUpdateStock' | translate : 'Update stock' }}
      </button>
    </div>
  </ng-container>
  <div class="col-6" style="text-align: right; padding-left: 5px; padding-right: 5px;">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()">
      {{'T4.Service.ServiceGuyDialog.cmdConfirm' | translate : 'Save' }}
    </button>
  </div>
</mat-dialog-actions>
